<!-- fixed-top-->
<nav
  class="header-navbar navbar-expand-md navbar navbar-with-menu navbar-without-dd-arrow fixed-top navbar-semi-dark navbar-shadow"
  >
  <div class="navbar-wrapper">
    <div class="navbar-header">
      <ul class="nav navbar-nav flex-row">
        <li class="nav-item mobile-menu d-md-none mr-auto">
          <a class="nav-link nav-menu-main menu-toggle hidden-xs" href="#"
            ><i class="fa fa-outdent"></i
          ></a>
        </li>
        <li class="nav-item">
          <a class="navbar-brand" routerLink="/dashboard">
            <img
              class="brand-logo center"
              src="../../../../assets/img/entrustedWhite.svg"
              alt="iCash Admin"
              style="width: 150px"
              />
          </a>
        </li>
        <li class="nav-item d-md-none">
          <a
            class="nav-link open-navbar-container"
            data-toggle="collapse"
            data-target="#navbar-mobile"
            ><i class="la la-ellipsis-v"></i
          ></a>
        </li>
      </ul>
    </div>
    <div class="navbar-container content">
      <div class="collapse navbar-collapse" id="navbar-mobile">
        <ul class="nav navbar-nav mr-auto float-left">
          <li class="nav-item d-none d-md-flex align-items-center">
            <span class="mr-1"
              >Hello
              <span class="user-name text-bold-700">{{
                $safeNavigationMigration(details?.name) | firstWord
                }}</span
                >,
              </span>
            </li>
          </ul>
          <ul class="nav navbar-nav float-right">
            <li class="dropdown dropdown-user nav-item">
              <a
                class="dropdown-toggle nav-link dropdown-user-link"
                href="#"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                title="Account menu"
                >
                <!--<i class="icons icon-admin-icon"></i>-->
                <span><i class="fa fa-user-circle-o fa-lg"></i></span>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <a class="dropdown-item" routerLink="/admin-profile"
                  ><i class="fa fa-user"></i> View Profile</a
                  >
                  <div class="dropdown-divider"></div>
                  @if (details?.permission === 'admin') {
                    <a
                      class="dropdown-item"
                      routerLink="/webhook"
                      ><i class="fa fa-sync"></i> WebHook</a
                      >
                    }
                    @if (details?.permission === 'admin') {
                      <div
                        class="dropdown-divider"
                      ></div>
                    }
                    <a class="dropdown-item" href="#" (click)="logout($event)"
                      ><i class="fa fa-sign-out"></i> Logout</a
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
